import React, { useEffect, useState } from 'react';
import { Filter, TextInput, SelectInput, useDataProvider, AutocompleteInput, DateInput, ReferenceInput } from 'react-admin';
import { InputAdornment, Button } from '@material-ui/core';
import { Search as SearchIcon } from '@material-ui/icons';
import { eventFilterStatus } from '../../utils/choices';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUndo } from '@fortawesome/pro-regular-svg-icons';

const EventFilters = (props) => {
  const [plots, setPlots] = useState([]);
  const [admins, setAdmins] = useState([]);

  const dataProvider = useDataProvider();

  useEffect(() => {
    dataProvider
      .getList('plot', {})
      .then(({ data }) => {
        const plotArray = data.map(({ id, name }) => ({ id, name }));
        setPlots(plotArray);
      })
      .catch((error) => {
        console.log(error);
      });

      dataProvider
      .getList('admin', {})
      .then(({ data }) => {
        const adminArray = data.map(({ id, email, role }) => ({
          id,
          name: email,
        }));
        setAdmins(adminArray);
      })
      .catch((error) => {
        console.log(error);
      });

  }, []);

  return (
    <>
      <Filter {...props}>
        <TextInput
          alwaysOn
          source="name"
          label="Event name"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <SearchIcon color="disabled" />
              </InputAdornment>
            ),
          }}
        />

        <SelectInput source="status" choices={eventFilterStatus} alwaysOn allowEmpty />
        {/* <SelectInput source="plotId" choices={plots} alwaysOn allowEmpty /> */}
        <AutocompleteInput
          source="plotId"
          choices={plots}
          shouldRenderSuggestions={(val) => val.trim().length > 0}
          alwaysOn
          allowEmpty
        />

        <ReferenceInput
          source='eventLocationId'
          reference='location'
          alwaysOn
          filterToQuery={searchText => (searchText ? { name: searchText }: {})}
          allowEmpty
        >
          <AutocompleteInput />
        </ReferenceInput>

        <AutocompleteInput
            source="eventDirectorId"
            choices={admins}
            shouldRenderSuggestions={(val) => val.trim().length > 0}
            label="Event Director"
            alwaysOn
            allowEmpty
          />

        <DateInput
          alwaysOn
          source='from'
        />

        <DateInput
          alwaysOn
          source='to'
        />

        <SelectInput choices={[
          { id: 'arch', name: 'Archived' },
          { id: 'all', name: 'All' },
        ]} source='unarchived' alwaysOn />

      </Filter>
      <Button style={{ marginTop: '15px', marginRight: '10px', paddingTop: '7px', width: '150px' }} onClick={() => { props.setFilters({}, [], false) }}>
        <FontAwesomeIcon style={{ marginRight: '5px' }} icon={faUndo} /> Reset form
      </Button>
    </>
  );
};

export default EventFilters;
